import { createAction } from "@reduxjs/toolkit";

export type MiniGamesRewardsData = {
  goldAmount: number;
};

export const miniGamesRewardsRequest = createAction(
  "miniGamesRewards/get/request",
);

export const miniGamesRewardsSuccess = createAction<MiniGamesRewardsData>(
  "miniGamesRewards/get/success",
);

export const miniGamesRewardsFailure = createAction<string>(
  "miniGamesRewards/get/failure",
);

export const miniGamesRewardsStop = createAction("miniGamesRewards/stop");

export type JackpotHistoryItem = {
  id: string;
  miniGameJackpotId: string;
  playerId: string;
  gameName: string;
  jackpotType: string;
  amount: number;
  createdAt: string;
};

export type JackpotHistoryData = JackpotHistoryItem[];

export const jackpotHistoryRequest = createAction(
  "jackpotHistory/get/request",
);

export const jackpotHistorySuccess = createAction<JackpotHistoryData>(
  "jackpotHistory/get/success",
);

export const jackpotHistoryFailure = createAction<string>(
  "jackpotHistory/get/failure",
);